export default __webpack_public_path__ + "static/media/hht1_ep09_timeline_q02_a.5a371c8d.png";